'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'paintbrush-fine';
var width = 576;
var height = 512;
var aliases = ["paint-brush-alt","paint-brush-fine","paintbrush-alt"];
var unicode = 'f5a9';
var svgPathData = 'M204.3 273.7L455 23.03C482.1-4.016 525.9-4.016 552.1 23.03C580 50.08 580 93.92 552.1 120.1L302.3 371.7C303.4 378.3 304 385.1 304 392C304 458.3 250.3 512 184 512H32C14.33 512 0 497.7 0 480C0 462.3 14.33 448 32 448H38.01C56.09 448 68.14 428.2 65.39 410.4C64.48 404.4 63.1 398.2 63.1 392C63.1 325.7 117.7 272 183.1 272C190.9 272 197.7 272.6 204.3 273.7H204.3zM306.2 239.7L336.3 269.8L519 87.03C527.3 78.73 527.3 65.27 519 56.97C510.7 48.67 497.3 48.67 488.1 56.97L306.2 239.7zM210.5 325C202.3 321.8 193.4 320 184 320C144.2 320 112 352.2 112 392C112 395.8 112.3 399.5 112.8 403.1C116.1 424.5 110.7 446.2 99.08 463.1L98.42 464H184C223.8 464 256 431.8 256 392C256 382.6 254.2 373.7 250.1 365.5L210.5 325z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPaintbrushFine = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;